import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {useIsScreenLargerThan} from 'app/general/mediaqueries';
import StateButton from 'app/general/widgets/StateButton';
import {useAutoRefreshingSignedUrl} from 'app/mediaaccess/hooks';
import {gt} from 'app/utils/i18n';

type FileProps = {
  MEDIA_URL_PROTECTED: string;
  file_ref: string;
  file_name: string;
};

export function FileAccessLink(props: FileProps) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${props.MEDIA_URL_PROTECTED}${props.file_ref}`}
    >
      {props.file_name}
    </a>
  );
}

export function GuestFileAccessLink(props: FileProps) {
  const {signed_url, refresh} = useAutoRefreshingSignedUrl(props.file_ref);
  const isBigScreen = useIsScreenLargerThan('sm');

  return (
    <LazyTooltip
      tooltip={gt(
        'This is a secured link to your file that refreshes itself automatically. If it ever stops working, use the refresh button to generate a new link.'
      )}
    >
      <StyledLinkDiv>
        <i className="fa fa-lock text-light mr-1" aria-hidden="true" />
        <a
          id="SecureLink"
          target="_blank"
          rel="noopener noreferrer"
          href={signed_url}
          className={cs('d-flex align-items-center', {
            'text-danger': !isBigScreen && signed_url == null,
          })}
        >
          {props.file_name}
        </a>
        <StateButton
          onClick={() => refresh()}
          className="btn btn-sm ml-1 text-muted"
          title={gt('Refresh secured link')}
        >
          <i className="fa fa-redo" />
        </StateButton>
      </StyledLinkDiv>
    </LazyTooltip>
  );
}

const StyledLinkDiv = styled.div.attrs({
  className: 'd-inline-flex align-items-center',
})`
  height: calc(1.5em + 2px);
`;
